import arrow from "../../images/arrow-8.svg"
import "./courses.css"
import badge from "../../images/badge_icon.svg"

function Card({ title, subtitle }) {
    return (
        <div className="card">
            <img className="card-icon" src={badge} alt="badge" />
            <div>
                <p className="card-title">{title}</p>
                <p className="card-subtitle">{subtitle}</p>
            </div>
        </div>
    )
}

export default function Courses() {
    const data = [
        {
            title: "ReactJS",
            subtitle: "Scrimba"
        },
        {
            title: "Flutter & Dart",
            subtitle: "Udemy"
        },
        {
            title: "Robotics",
            subtitle: "Universal Robots"
        },
        {
            title: "The Fundamentals of Digital Marketing",
            subtitle: "Google Digital Garage"
        }
    ]

    const dataComponents = data.map((x, idx) => (
        <Card
            key={idx}
            title={x.title}
            subtitle={x.subtitle}
        />
    ))

    return (
        <div className="courses">
            <img className="courses-arrow" src={arrow} alt='arrow' />
            <h2 className="courses-header">Certificates</h2>
            <div className="courses-main">{dataComponents}</div>
        </div>
    )
}